import { IToken } from 'shared/models/Betby'

export class BetbyConverter {
  convertToken(data: IToken): string {
    return data.access_token
  }
}
